import { ValidationError } from "yup";
import { type AppContext } from "~/lib/context";
import { getAllowedJobFamilyIds } from "~/services/job";

export const validateJobsAuthorised = async (ctx: AppContext, jobsIds: number[]) => {
  const allowedJobFamilyIds = getAllowedJobFamilyIds(ctx.user);

  if (!allowedJobFamilyIds?.length) {
    return;
  }

  const jobs = await ctx.prisma.job.findMany({ where: { id: { in: jobsIds } } });
  const restrictedJob = jobs.find((job) => !allowedJobFamilyIds.includes(job.familyId));

  if (restrictedJob) {
    throw new ValidationError("Unauthorised job", restrictedJob.id, "jobsIds");
  }
};
